import React, { useState } from "react";
import PropTypes from "prop-types";
import FaqItem from "./faq-item";
import Icon from "@mdi/react";
import { mdiChevronDown } from "@mdi/js";
import "./faqs.m.css";
import {CONTACT} from '../../../../constants';

const Faqs = ({ faqs }) => {
  const [state, setMore] = useState({ more: false });
  const showMore = () => {
    const flag = state.more;
    setMore({ more: !flag });
  };
  const items = state.more ? faqs.items : faqs.items.slice(0, 4);
  return (
    <div id="faqs" styleName="pn-faq-wrapper" className="container">
      <div styleName="pn-faq-header-text">
        <div styleName="faqs-text"> FAQs </div>
        <div styleName="title"> We Are Here For You </div>
        <div styleName="line"></div>
        <div styleName="btn-wrap">
          <div styleName="desc">
            Still can’t find what you’re looking for?
          </div>
          <a styleName="btn-style" href={`mailto:${CONTACT.SUPPORT_ID}`}>
            Get in Touch &nbsp;
            <img
              src="/icons/ic_chevron_right_white_24px.svg"
              height="8px"
              width="8px"
            />
          </a>
        </div>
      </div>
      <div styleName="row">
        <div styleName="col-12 col-sm-12">
          <div styleName="pn-accordian">
            {items.map((item, index) => (
              <FaqItem key={index} item={{ ...item, index }} />
            ))}
          </div>
          {!state.more && (
            <div styleName="view-all-wrapper">
              <button onClick={showMore} styleName="pn-faq-btn">
                View All
                <Icon path={mdiChevronDown} size="22px" color="#725E42" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
Faqs.propTypes = {
  faqs: PropTypes.object.isRequired,
};
export default Faqs;
